<template>
  <div class="uploader-file-warp">
    <div class="uploader-file-icon">
      <svg class="iconfontcss" aria-hidden="true">
        <use
          v-if="filetype === 'compressFile'"
          xlink:href="#icon-yasuobao"
        ></use>
        <use v-if="filetype === 'video'" xlink:href="#icon-shipinshebei"></use>
        <use v-if="filetype === 'audio'" xlink:href="#icon-music"></use>
        <use
          v-if="filetype === 'ios'"
          xlink:href="#icon-pingguoanzhuangwenjian-ipa_dmg"
        ></use>
        <use v-if="filetype === 'android'" xlink:href="#icon-apk"></use>
        <use v-if="filetype === 'exe'" xlink:href="#icon-exe"></use>
        <use v-if="filetype === 'other'" xlink:href="#icon-wenjian"></use>
      </svg>
    </div>
    <div class="uploader-file-info">
      <div class="uploader-file-name">{{ file.name }}</div>
      <el-progress
        :percentage="percentage"
        color="#3fbbff"
        :show-text="false"
      ></el-progress>
      <div class="uploader-file-size">{{ transformByte(file.size) }}</div>
      <div class="uploader-file-status">
        <span
          v-show="status !== '上传中'"
          :class="status === '上传失败' ? 'errorcss' : ''"
          >{{ status }}</span
        >
        <span v-show="status === '上传中'">{{ formatedAverageSpeed }}</span>
        <span v-show="status === '计算md5中'"
          >&nbsp;{{ file.md5prevProgress }}</span
        >
      </div>
    </div>
    <div class="uploader-file-actions">
      <i
        class="btn iconfont icon-kaishi1"
        v-if="
          status !== '上传中' &&
          status !== '计算md5中' &&
          status !== '等待中' &&
          status !== '文件分片中'
        "
        @click="handleResume"
      ></i>
      <i
        class="btn iconfont icon-24gl-pause2"
        v-if="status === '上传中'"
        @click="handlePause"
      ></i>
      <i class="btn iconfont icon-reeor" @click="handleRemove"></i>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";
import "@/Assets/Icon/iconfont";

const props = defineProps({
  file: {
    type: Object,
    default() {
      return {};
    },
  },
});

const filetype = computed(() => {
  if (
    ["jar", "zip", "rar", "7z", "cab", "iso", "tar", "uue", "gz"].some(
      (a) => props.file.fileType.indexOf(a) > -1
    )
  ) {
    return "compressFile";
  } else if (
    [
      "cda",
      "wav",
      "mp3",
      "wma",
      "ra",
      "midi",
      "ogg",
      "ape",
      "flac",
      "acc",
      "audio",
    ].some((a) => props.file.fileType.indexOf(a) > -1)
  ) {
    return "audio";
  } else if (
    [
      "avi",
      "mov",
      "mpg",
      "mpeg",
      "mpe",
      "dat",
      "vob",
      "asf",
      "3gp",
      "mp4",
      ".wmv",
      "rm",
      "rmvb",
      "flv",
      "mkv",
    ].some((a) => props.file.fileType.indexOf(a) > -1)
  ) {
    return "video";
  } else if (["apk"].some((a) => props.file.fileType.indexOf(a) > -1)) {
    return "android";
  } else if (
    ["ipa", "archive", "dmg"].some((a) => props.file.fileType.indexOf(a) > -1)
  ) {
    return "ios";
  } else if (["exe"].some((a) => props.file.fileType.indexOf(a) > -1)) {
    return "exe";
  } else {
    return "other";
  }
});

const percentage = computed(() => {
  return Math.floor(props.file.prevProgress * 100)
});

function transformByte(val) {
  if (val < 1024) {
    return val.toFixed(0) + " bytes";
  } else if (val < 1024 * 1024) {
    return (val / 1024.0).toFixed(0) + " KB";
  } else if (val < 1024 * 1024 * 1024) {
    return (val / 1024.0 / 1024.0).toFixed(1) + " MB";
  } else {
    return (val / 1024.0 / 1024.0 / 1024.0).toFixed(1) + " GB";
  }
}

const status = computed(() => {
  const _state = props.file.state;
  if (_state === "complete") {
    return "上传完成";
  } else if (_state === "flashcomplete") {
    return "闪存完成";
  } else if (_state === "error") {
    return "上传失败";
  } else if (_state === "uploading") {
    return "上传中";
  } else if (_state === "pause") {
    return "暂停中";
  } else if (_state === "chunking") {
    return "文件分片中";
  } else if (_state === "computemd5") {
    return "计算md5中";
  } else if (_state === "verifyUpload") {
    return "校验文件中";
  } else if (_state === "notify") {
    return "合并文件中";
  } else if (_state === "notifyfail") {
    return "合并文件失败";
  } else {
    return "等待中";
  }
});
const formatedAverageSpeed = computed(() => {
  return `${transformByte(props.file.averageSpeed)}/s`;
});

function handleResume() {
  if (props.file.state === "complete" || props.file.state === "flashcomplete") {
    props.file.retry();
  } else if (props.file.state === "notifyfail") {
    props.file.notify();
  } else {
    props.file.resume();
  }
}
function handlePause() {
  props.file.pause();
}
function handleRemove() {
  props.file.cancel();
}
</script>

<style lang="scss" scoped>
.uploader-file-warp {
  margin-left: 10px;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 5px;
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.uploader-file-icon {
  color: #000;
}

.uploader-file-info {
  width: 200px;
  padding: 0 8px;
  position: relative;
}

.uploader-file-actions {
  display: flex;
  align-items: center;
}

.uploader-file-name {
  font-size: 14px;
  font-weight: bold;
  margin-left: 3px;
  margin-bottom: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.uploader-file-size {
  font-size: 12px;
  margin-top: 3px;
  margin-left: 3px;
}

.uploader-file-status {
  font-size: 12px;
  position: absolute;
  top: 34px;
  right: 0px;
  color: #3fbbff;
}

.btn {
  font-size: 20px;
  cursor: pointer;
  color: #868686;
  &:hover {
    color: #3fbbff;
  }
}

.errorcss {
  color: #ff0000;
}

.iconfontcss {
  width: 26px;
  height: 26px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
